/** Presentation-only contracts. Product adapters own identity, authorization and persistence. */
export interface ApplicationNavigationItem {
    id?: string;
    title?: string;
    icon?: string;
    link?: string;
    exactMatch?: boolean;
    children?: readonly ApplicationNavigationItem[];
}

export interface ApplicationBreadcrumb { label: string; url: string; }

export function normalizeMenuText(value: string): string {
    return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd');
}

export function applicationRoute(value?: string): string {
    return '/' + (value ?? '').split(/[?#]/)[0].split('/').filter(Boolean).join('/');
}

export function filterApplicationNavigation(groups: readonly ApplicationNavigationItem[], query: string,
    translate: (key: string) => string): readonly ApplicationNavigationItem[] {
    const search = normalizeMenuText(query.trim());
    if (!search) return groups;
    return groups.map(group => ({ ...group, children: normalizeMenuText(translate(group.title ?? '')).includes(search)
        ? group.children : (group.children ?? []).filter(item => normalizeMenuText(translate(item.title ?? '')).includes(search)) }))
        .filter(group => !!group.children?.length);
}

/** Exact matching for parent entries prevents two active leaves on a nested route. */
export function exactApplicationRoutes(groups: readonly ApplicationNavigationItem[]): ReadonlySet<string> {
    const routes = groups.flatMap(group => (group.children ?? []).map(item => applicationRoute(item.link)));
    return new Set(routes.filter(route => route === '/' || routes.some(other => other !== route && other.startsWith(route + '/'))));
}
